import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      rowGap: 20,
      padding: '40px 75px',
    },
    fxgiants: {
      backgroundColor: variables.lavander,
      color: variables.shadowBlue,
    },
    fxcess: {
      backgroundColor: variables.brightGrey,
      color: variables.black,

      '& svg': {
        '& path': {
          fill: variables.red,
        },
      },
    },
    fxcessLogo: {
      width: 160,
    },
    tigerFx: {
      color: variables.gray,
      backgroundColor: variables.lavanderGhostWhite,
      justifyContent: 'flex-start',
    },
    tigerFxLogo: {
      width: 60,
      transform: 'scale(-1, 1)',
    },
    xlence: {
      color: variables.spanishGrey,
    },
    xlenceLogo: {
      width: 127,
    },
    ironFXLogo: {
      width: 127,
    },
    TradingSphere: {
      color: '#172d2980',
    },
    TradingSphereWarning: {
      color: '#172d2980',
      fontWeight: 600,
      fontSize: 16,
    },
    socialMedia: {
      display: 'flex',
      columnGap: 30,
    },
    logoImg: {
      width: 200,
      '@media (max-width: 1024px)': {
        width: 84,
      },
    },
    brandName: {
      fontSize: 15,
      fontWeight: 700,
      textTransform: 'uppercase',
      color: variables.black,
    },
    warning: {
      color: variables.black,
      fontWeight: 700,
    },
    gap: {
      gap: 20,
    },
    item: {
      width: '49%',

      '@media (max-width: 1025px)': {
        width: '100%',
      },
    },
    xlenceInfoItems: {
      display: 'flex',
      columnGap: 40,
    },
    xlenceItem: {
      display: 'flex',
      rowGap: 20,
      fontWeight: 400,
      width: '48%',
    },

    ironFXInfoItems: {
      display: 'flex',
      columnGap: 40,
    },
    ironFXItem: {
      display: 'flex',
      rowGap: 20,
      fontWeight: 400,
      width: '48%',

      '@media (max-width: 1025px)': {
        width: '100%',
      },
    },
  }),
);
